// extracted by mini-css-extract-plugin
export default {"section":"Section_section__0XkUm","default":"Section_default__LZjGC","surface":"Section_surface__yCOHz","primary":"Section_primary__-wM0Z"};